import styled from 'styled-components'

import arrowBack from 'assets/images/arrow-left.svg'
import closeIcon from 'assets/images/femi-close.svg'

import { FemiColor } from '../../constants'

const IconButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  outline: none;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`

export const StyledFemiPageContainer = {
  Navigation: styled.div<{ hasDownloadBanner: boolean }>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 52px;
    margin-top: ${({ hasDownloadBanner }) =>
      hasDownloadBanner ? '56px' : '0'};
    padding: 0 40px;
    background-color: ${FemiColor.WHITE};
    box-shadow: 0 -0.5px 0 0 rgba(0, 0, 0, 0.25) inset;
  `,
  NavigationTitle: styled.p`
    color: ${FemiColor.BLACK};
    font-size: 15px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
  `,
  BackButton: styled(IconButton)`
    inset-inline-start: 8px;
    background-image: url(${arrowBack});

    [dir='rtl'] & {
      transform: translateY(-50%) scaleX(-1);
    }
  `,
  CloseButton: styled(IconButton)`
    inset-inline-end: 8px;
    background-image: url(${closeIcon});
  `,
  Content: styled.div<{ hasTopOffset: boolean }>`
    padding-top: ${({ hasTopOffset }) => (hasTopOffset ? '56px' : '0')};
    padding-bottom: 24px;
  `,
}
